var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueTagsInput',{attrs:{"tags":_vm.tags,"placeholder":"Saisissez une valeur"},on:{"tags-changed":function (newTags) { return _vm.tags = newTags; }},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e92d80e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/formbuilder/elements/TagsManager.vue
// module id = null
// module chunks = 